/* eslint-disable max-len */
export default {
  ACTION: {
    ACCEPT_TERMS_AND_CONTINUE: 'Aceitar e continuar',
    APPROVE: 'Aprovar',
    CANCEL: 'Cancelar',
    SAVE: 'Gravar'
  },
  ERROR: {},
  HEADER: {},
  LABEL: {
    ACCEPT_TERMS_CHECKBOX: 'Li e aceito os Termos e Condições',
    ACCEPT_TERMS_DESCRIPTION:
      'Antes de aceder à plataforma Prozis Partnership, leia e aceite os Termos e Condições do Programa de Influenciadores Prozis.',
    ACCEPT_TERMS_NAV_TITLE: 'Termos e Condições',
    ACCEPT_TERMS_SCROLL_HINT: 'Lê até ao fim para poderes continuar.',
    DASHBOARD: 'Dashboard',
    ENABLE_NOTIFICATIONS_DESCRIPTION:
      'Reparamos que não tens as notificações ativas, para poderes continuar a usar aplicação precisamos que atives as notificações.',
    ENABLE_NOTIFICATIONS_LINK: 'Podes ativar as notificações aqui',
    ENABLE_NOTIFICATIONS_NAV_TITLE: 'Notificações',
    ENABLE_NOTIFICATIONS_TITLE: 'Ativa as notificações para poder continuar',
    HOME: 'Início',
    INSTALL_PROZIS_APP: 'Instala a aplicação Prozis Store',
    INSTALL_PROZIS_APP_DESCRIPTION:
      'Instala a nossa aplicação móvel para continuar a aceder a todas as funcionalidades.',
    INSTALL_PROZIS_APP_NAV_TITLE: 'Instalar aplicação',
    LOGOUT: 'Sair',
    NOT_FOUND: 'Não encontrado',
    OR: 'Ou',
    OR_SCAN_QR_CODE: 'Ou lê o código QR',
    SCAN_QR_CODE: 'Lê o código QR com o teu dispositivo móvel',
    TODOS: 'Todos',
    UNAUTHORIZED_DESCRIPTION_1:
      'Verifique com seu gestor as permissões de acesso.',
    UNAUTHORIZED_DESCRIPTION_2:
      'Após a verificação, tente fazer login novamente.',
    UNAUTHORIZED_NAV_TITLE: 'Acesso negado',
    UNAUTHORIZED_TITLE: 'Sem acesso'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
